<div class="lvi-content">
    <div class="avatar" [ngClass]="{ 'warning': data.listeAlertes?.niveau == 1,'danger': data.listeAlertes?.niveau == 2 }">
        <i class="nio icon-ordre_de_mission"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="dashboard-list-title" [routerLink]="" (click)="navigateTo()">
                {{ data.idOd || ('od.liste.numeroNonDefini' | translate) }} - {{ data.objet || ('od.liste.objetNonDefini' | translate) }}
            </a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.location" [matTooltip]="data.location + ', ' + data.pays.libelle.toUpperCase()">
                <strong [translate]="'dashboard.listeOD.destination'"></strong>
                <span *ngIf="data.pays?.code2" class="flag-icon me-1" [ngClass]="'flag-icon-'+data.pays.code2.toLowerCase()"></span>
                <span>{{ data.location }}</span>
            </li>
            <li><strong [translate]="'dashboard.listeOD.montant'"></strong><span>{{ data.montantProposition | montant: settings ? settings.deviseEntreprise : '' }}</span></li>
        </ul>
    </div>
    <div class="info">
        <statut [statut]="data.statut" [isMinimized]="true"></statut>
    </div>
</div>
